import { Component } from '@angular/core';
import {
  AgGridButtonRendererProperties,
  AgGridButtonRendererActions,
} from '../../models/ag-grid-button-renderer.model';

@Component({
  standalone: false,
  selector: 'ag-grid-button-renderer',
  templateUrl: './ag-grid-button-renderer.component.html',
  styleUrls: ['./ag-grid-button-renderer.component.scss'],
})
export class AgGridButtonRenderer {
  props!: AgGridButtonRendererProperties;
  private actions: AgGridButtonRendererActions;
  data: any;

  constructor() {
    this.actions = {
      setProps: (props) => (this.props = props),
    };
  }

  agInit(params: any): void {
    this.data = params.data;
    params.onInit(this.actions, params.data);
  }
}
